var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('totp-qr-code',{attrs:{"loginUserDetail":_vm.loginUserDetail,"totpSecretKey":_vm.totpSecretKey}}),_c('totp-login-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }